import { h } from 'vue'
import { CloseCircleFilled, ClockCircleFilled, CheckCircleFilled , ExclamationCircleFilled, PauseCircleFilled, StopFilled} from '@ant-design/icons-vue';

export const getIconByStatus = (status) => {
  if (!status || status == '') {
    return
  }
  // console.log(status)
  let ingStatus = ['un_start','dealing','doing','un_submit','un_confirm', 'in_approval', 'plat_approve',
    'in_approve','in_process','un_submit_delivery','un_release','un_started',
    "live_in_approve", "in_started", 'drug_co_confirm_pass', 'provincial_in_approve',
    'project_dept_in_approve','wait_approval', 'in_approve_delivery',
    'del_in_approval','edit_in_approval', 'replace_approve', 'un_check', 'checking', 'unchecked'
  ]
  if (ingStatus.includes(status)) {
    return h(ClockCircleFilled, {style: 'color: #FFC440;'}, () => status);
  }
  let errStatus = ['reject','rejected','approval_unpass','un_approve_pass','unpass','approval_un_pass',
    'live_approve_unpass', 'un_approve_pass_delivery', 'check_unpass',
    'rejected_un_submit', 'drug_co_confirm_unpass', 'approve_drug_co_unpass','approve_unpass', 'unqualified']
  if (errStatus.includes(status)) {
    return h(CloseCircleFilled, {style: 'color: #FD6255;'}, () => status);
  }
  let okStatus = ['finish','approval_pass','approve_pass',"end", "live_approve_pass", "cancel", 'approve_drug_co_pass','confirm', 'check_pass', 'qualified']
  if (okStatus.includes(status)) {
    return h(CheckCircleFilled, {style: 'color: #39D0B6;'}, () => status);
  }
  let onStatus = ['no_need_check']
  if(onStatus.includes(status)) {
    return h(StopFilled, {style: 'color: #2C68FF;'}, () => status);
  }
}
/*
* 专员实名认证图标
* */
export const getIconByRegisterStatus = (status) => {
  if (!status || status == '') {
    return
  }
  let registerFail = ['fail'];
  if(registerFail.includes(status)){
    return h(ExclamationCircleFilled, {style: 'color: #FFC440;'}, () => status);
  }
  let registerSuccess = ['success'];
  if(registerSuccess.includes(status)){
    return h(CheckCircleFilled, {style: 'color: #39D0B6;'}, () => status);
  }
}

/*
* 表单模版启用禁用图标
* */
export const getIconBySwitchStatus = (status) => {
  if (!status || status == '') {
    return
  }
  let registerFail = ['0'];
  if(registerFail.includes(status)){
    return h(CloseCircleFilled, {style: 'color: #FD6255;'}, () => status);
  }
  let registerSuccess = ['1'];
  if(registerSuccess.includes(status)){
    return h(CheckCircleFilled, {style: 'color: #39D0B6;'}, () => status);
  }
}

/*
* 用户状态图标
* */
export const getIconByUserStatus = (status) => {
  if (!status || status == '') {
    return
  }
  let registerFail = [2];
  if(registerFail.includes(status)){
    return h(CloseCircleFilled, {style: 'color: #FD6255;'}, () => status);
  }
  let registerSuccess = [1];
  if(registerSuccess.includes(status)){
    return h(CheckCircleFilled, {style: 'color: #39D0B6;'}, () => status);
  }
}

export const getSchedulesStatusIcon = (status) =>{
  if (!status || status == '') {
    return
  }
  let ingStatus = ['running']
  if (ingStatus.includes(status)) {
    return h(ClockCircleFilled, {style: 'color: #FFC440;'}, () => status);
  }
  let errStatus = ['canceled']
  if (errStatus.includes(status)) {
    return h(CloseCircleFilled, {style: 'color: #FD6255;'}, () => status);
  }
  let pauseStatus = ['suspended'];
  if (pauseStatus.includes(status)) {
    return h(PauseCircleFilled, {style: 'color: #FFC440;'}, () => status);
  }
  let okStatus = ['finished']
  if (okStatus.includes(status)) {
    return h(CheckCircleFilled, {style: 'color: #39D0B6;'}, () => status);
  }
}
